import { OidcService, TokenOidcService } from ".."
import { DesktopWidgetOidcService } from "../services/desktop-widget-oidc/desktop-widget-oidc-service"
import { HybridOidcService } from "../services/hybrid-oidc/hybrid-oidc-service"
import { ProxyOidcService } from "../services/proxy-oidc/proxy-oidc-service"
import { OidcConfig } from "../types/oidc-config"

export class OidcServiceFactory {
  private oidcConfig: OidcConfig
  private proxy: boolean
  private isDesktopWidget: boolean

  constructor(oidcConfig: OidcConfig, proxy?: boolean, isDesktopWidget?: boolean) {
    this.oidcConfig = oidcConfig
    this.proxy = proxy ?? false
    this.isDesktopWidget = isDesktopWidget ?? false
  }

  public async getOidcService(): Promise<OidcService | null> {
    if(this.isDesktopWidget) {
      const desktopWidgetOidcService = new DesktopWidgetOidcService()
      return await this.initService(desktopWidgetOidcService)
    }

    if(this.proxy) {
      const proxyService = new ProxyOidcService()
      return await this.initService(proxyService)
    }

    const tokenService = new TokenOidcService(this.oidcConfig)
    if (tokenService.isActiveFlow())
      return await this.initService(tokenService)

    const hybridService = new HybridOidcService(this.oidcConfig)
    return await this.initService(hybridService)
  }

  private initService = (service: OidcService): Promise<OidcService | null> => {
    return service.init()
      .then(() => { return service })
      .catch(error => {
        switch (error.status) {
          case 401:
            service.signinRedirect();
            return null;
          default:
            return Promise.reject({ message: "Unable to initialize OIDC Service." })
        }
      })
  }
}
